import instance from '@/services/repository';

const resource = '/useralerts';

export default {
    get(query: IUserAlertsQuery) {
        return instance.get<IUserAlert[]>(`${resource}?page=${query.page}&pageSize=${query.pageSize}`);
    },
    acknowledge(id?: string) {
        if (id) {
            return instance.post(`${resource}/acknowledge/${id}`);
        }
        return instance.post(`${resource}/acknowledge/all`);
    },
};
